import React from 'react';

export const TourMenu = ({ onSelectTour, tours }) => {

  if (Object.keys(tours).length === 0) {
    return;
  }

  if (Object.keys(tours).length === 1) {
    const tourID = Object.keys(tours)[0];
    return (
      <button
        className='btn btn-secondary'
        id='tour-menu-button'
        onClick={() => typeof(onSelectTour) === 'function' && onSelectTour(tourID)}
      >
        <i className='fa fa-magic'></i>
        <span className='text'>
          Take a feature tour
        </span>
      </button>
    )
  }

  return (
    <div className="btn-group dropup">
      <button
        aria-expanded="false"
        aria-haspopup="true"
        className="btn btn-secondary dropdown-toggle"
        data-toggle="dropdown"
        id="tour-menu-button"
        title="Take a feature tour"
        type="button"
      >
        <i className='fa fa-magic'></i>
        <span className='text'>
          Take a feature tour
        </span>
      </button>
      <div className="dropdown-menu">
        {
          Object.entries(tours).map(
            ([tourID, tour]) => {
              return (
                <button
                  className='dropdown-item'
                  key={tourID}
                  onClick={() => typeof(onSelectTour) === 'function' && onSelectTour(tourID)}
                >
                  {tour.name}
                </button>
              )
            }
          )
        }
      </div>
    </div>
  );
};
